import React from 'react';
import PropTypes from 'prop-types';
import Button from '@adsk/alloy-react-button';
import { useLocale } from '@adsk/alloy-react-helpers';
import { useStore } from '../../../StoreProvider';
import { cancelButtonStyle } from './helpers/styles';

const Footer = ({
  confirmButtonText,
  onCancelClick,
  onInviteClick,
  inviteDisabled,
  isSaving,
}) => {
  const { T } = useLocale(({ locale }) => require(`../../i18n/${locale}.json`));
  const {
    state: {
      emails,
      isNewCompany,
      selectedAccessLevel,
      selectedAccountAccessLevels,
      selectedCompany,
      selectedRole,
      productsAccesses,
    },
  } = useStore();

  const handleOnInviteClick = () => {
    onInviteClick({
      emails,
      isNewCompany,
      selectedAccessLevel,
      selectedAccountAccessLevels,
      selectedCompany,
      selectedRole,
      productsAccesses,
    });
  };

  return (
    <>
      <Button
        data-testid="InviteProjectMemberModal_cancel_button"
        onClick={onCancelClick}
        style={cancelButtonStyle}
        variant={Button.VARIANTS.TERTIARY}
      >
        {T.translate('FOOTER_CANCEL_BUTTON')}
      </Button>
      <Button
        data-testid="InviteProjectMemberModal_confirm_button"
        disabled={inviteDisabled}
        onClick={handleOnInviteClick}
        variant={Button.VARIANTS.PRIMARY}
        loading={isSaving}
      >
        {confirmButtonText}
      </Button>
    </>
  );
};

Footer.propTypes = {
  confirmButtonText: PropTypes.string.isRequired,
  inviteDisabled: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool,
  onCancelClick: PropTypes.func.isRequired,
  onInviteClick: PropTypes.func.isRequired,
};

export default Footer;
